import { useMemo } from 'react';

import { Overlay } from './Overlay';
import { mergeSx } from '../../../../../utils';
import * as Icons from '../../../../icons';
import { NoData, NoDataProps } from '../../../../placeholders/NoData';
import { useChartContext } from '../../../ChartProvider';
import { ChartContainerProps } from '../types';

type Props = {
  userProps?: ChartContainerProps<unknown>['noDataOverlayProps'];
  testId?: string;
};

const defaultNoDataProps: NoDataProps = {
  title: 'No data available',
  body: 'Try selecting a different period',
  icon: <Icons.MagnifyingGlass />,
};

const defaultZoomedNoDataProps: NoDataProps = {
  title: 'No data available',
  body: 'Zoom out to see more data',
  icon: <Icons.MagnifyingGlass />,
};

export const NoDataOverlay = ({ userProps, testId }: Props) => {
  const { hasZoomed } = useChartContext();

  const noDataProps = useMemo(() => {
    if (hasZoomed) return defaultZoomedNoDataProps;
    if (!userProps) return defaultNoDataProps;
    return {
      ...defaultNoDataProps,
      ...userProps,
    };
  }, [userProps, hasZoomed]);

  return (
    <Overlay>
      <NoData
        iconWrapperProps={{
          sx: mergeSx({ mb: 8 }, noDataProps.iconWrapperProps?.sx),
          ...noDataProps.iconWrapperProps,
        }}
        testId={testId}
        {...noDataProps}
      />
    </Overlay>
  );
};
